// R-94: the words filter's matching, with no React (unit-tested from Deno: tests/feat_browse_test.ts). The same rules as
// the server (supabase/functions/_shared/browse_filters.ts): keep the two in step.
export type Words = { inc: string[]; exc: string[] }
export const MAX_WORDS = 12
export const WORD_MAX_LEN = 40
/** The same cleaning the server does, so the chips show what is matched. */
const norm = (s: string) => s.toLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g, '').replace(/[^\p{L}\p{N}]+/gu, ' ').trim()
export function cleanWord(s: string): string {
  return norm(s.slice(0, WORD_MAX_LEN * 2)).slice(0, WORD_MAX_LEN).trim()
}

// The server's matcher (supabase/functions/_shared/browse_filters.ts), for answers already on screen (an ask on Browse) when
// a word changes: the same text, the same word-start rule, exclude wins. Keep the two in step.
const hostOf = (u: string | null | undefined) => { try { return u ? new URL(u).hostname : '' } catch { return '' } }
const siteOf = (u: string | null | undefined) => hostOf(u).replace(/^www\./, '').replace(/\.[a-z]{2,}$/i, '')
type Wordy = { title: string; venue_name?: string | null; source_name?: string | null; url?: string | null; ticket_url?: string | null; judged_by?: string | null }
export function keepsWords(it: Wordy, w: Words): boolean {
  if (!w.inc.length && !w.exc.length) return true
  const text = ` ${norm(`${it.title ?? ''} ${it.venue_name ?? ''} ${it.source_name ?? ''}`)} `
  const tags = (it.title ?? '').match(/#[\p{L}\p{N}_]+/gu)?.join(' ') ?? ''
  const squash = norm(`${it.source_name ?? ''} ${siteOf(it.url)} ${siteOf(it.ticket_url)} ${it.judged_by ?? ''} ${tags}`).replace(/ /g, '')
  const phrase = squash + norm(it.title ?? '').replace(/ /g, '')
  const hit = (x: string) => text.includes(` ${x}`) || (x.includes(' ') ? phrase.includes(x.replace(/ /g, '')) : x.length >= 5 && squash.includes(x))
  if (w.exc.some(hit)) return false
  return !w.inc.length || w.inc.some(hit)
}
